import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Carousel from '@src/components/Carousel';
import Separator from '@src/components/Separator';
import { Body1, Body2, H2 } from '@src/components/Typography';
import { windowWidth } from '@src/configuration/constants';
import { idKeyExtractor, padding } from '@src/configuration/constants';
import { PrimePlan, Slide } from '@src/types';

const size_ = windowWidth * 0.114;
const sizeSmall_ = windowWidth * 0.124;
export const Slides = styled.View`
  min-height: 230px;
  margin-bottom: 10px;
`;
export const RowIcons = styled.View<{ margin?: Boolean }>`
  flex-direction: row;
  align-items: center;
  padding-left: ${({ margin }) => (margin ? 16 : 0)}px;
`;
export const BottomButton = styled.View`
  position: absolute;
  bottom: 0;
  left:0px;
  right :0px
  justify-content: center;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 64px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.3);
  background-color: ${({ theme }) => theme.colors.background};
  shadow-offset: {width: 0, height:0};
  shadow-opacity: 1;
  shadow-radius: 8;
  width:100%;
  elevation: 1;
`;
export const RowContainer = styled.View`
  flex-direction: row;
  margin-top: 8px;
  justify-content: space-between;
  align-items: center;
`;
export const IconView = styled.View<{ margin?: number; isSmall?: boolean }>`
  width: ${({ isSmall }) => (isSmall === true ? sizeSmall_ : size_)}px;
  align-items: center;
  justify-content: center;
  padding-left: ${({ margin }) => margin}px;
`;
const ViewPlans = styled.View`
  border-radius: 4px;
  margin-top: 6px;
  background-color: ${({ theme }) => theme.colors.gold};
  padding: 4px;
`;

export const Plans = styled.View`
  min-height: 100px;
`;

export const Controls = styled.View`
  padding: ${padding}px;
`;

export const ContentTitle = styled(H2)`
  text-align: center;
`;

export const ContentSubtitle = styled(Body2)<{
  weight?: number;
  color?: string;
}>`
  text-align: center;
  font-weight: ${({ weight }) => (weight ? weight : 400)};
  color: ${({ theme, color }) =>
    color ? color : theme.colors.primaryDisabled};
`;
export const ControlView = styled.View`
  padding: 12px;
  border: 1.5px;
  border-radius: 16px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-color: ${({ theme }) => theme.colors.primaryDisabled};
`;
export const TitleCompare = styled(Body1)<{ margin?: Boolean }>`
  font-weight: 600;
  margin-top: ${({ margin }) => (margin ? '2px' : '0px')};
`;
export const SubtitleComapre = styled(Body1)<{ margin?: Boolean }>`
  font-weight: 400;
  margin-top: ${({ margin }) => (margin ? '2px' : '0px')};
`;
export const SubtitleComapreSmall = styled(Body2)<{ margin?: Boolean }>`
  font-weight: 400;
  margin-top: ${({ margin }) => (margin ? '2px' : '0px')};
`;
export const PrimePlanList = styled(
  FlatList as new () => FlatList<PrimePlan>
).attrs(() => ({
  removeClippedSubviews: true,
  initialNumToRender: 3,
  maxToRenderPerBatch: 3,
  scrollEventThrottle: 16,
  keyExtractor: idKeyExtractor,
  contentContainerStyle: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  ItemSeparatorComponent: Separator,
  horizontal: true,
}))``;

export const PlansCarousel = styled(
  Carousel as new () => Carousel<Slide>
).attrs(() => ({
  loop: true,
  directionalLockEnabled: true,
  enableMomentum: true,
}))``;
